import React, { Component } from 'react';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Select,
} from 'antd';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { queryIncCustomList, queryIncCustomProject } from '@api/incubator/custom';
import {
  queryDeleteIncuSettled,
  queryRenewBusinessInfo,
  querySaveIncuSettled,
} from '@api/incubator/settled';

import moment from 'moment';
import sessionDb from '@util/sessionDb';
import { getDate, getMonthNums } from '@util/formatDate';
import { getIncuBaseList } from '@store/modules/incubator/incubator_list';

import { BackBtn } from '@comm/BackBtn';
import FlowOp from '@comm/workflow/submitOp';
import TableRenew from '../comm/TableRenew';
import TableFile from '../../comm/TableFile';
import TableAppoint from '../comm/TableAppoint';
import ModalSettledList from '../comm/ModalRenew';
import ComSeatTable from '../../seat/ComSeatTable';
import ModalFileList from '../../comm/ModalFileList';
import ModalCarry from '../../bill/detail/ModalCarry';

const { Option } = Select;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const dateFormat = 'YYYY-MM-DD';

class PageStation extends Component {
  constructor(props) {
    const data = sessionDb.get('pageStationData') || props.data;
    let renewFlag = 0;
    let renewBusinessUuids = [];
    if (data) {
      if (data.renewBusinesses && data.renewBusinesses.length > 0) {
        renewFlag = 1;
        renewBusinessUuids = data.renewBusinesses.map((item, index) => {
          return item.uuid;
        });
      } else {
        renewFlag = data.renewFlag || 0;
      }
    }
    super(props);
    this.state = {
      data,
      customUuid: data ? data.customUuid : '',
      incubatorUuid: data ? data.incubatorUuid : this.props.params.uuid,
      payables: data ? data.payables : [],
      indeposit: data ? data.indeposit : 0,

      discount: '',
      originalPrice: '',
      price: data ? data.price : 0,
      fileList: data ? data.files || data.fileList || [] : [],

      renewFlag,
      renewBusinessUuids,
      renewBusinesses: data ? data.renewBusinesses : [],

      stations: data ? data.stations || [] : [],
      stationUuids: data && data.stations ? data.stations.map(item => item.uuid) : [],

      customList: [],
      projectList: [],
      visible: false,
      fileVisible: false,
      carryVisible: false,
      settledVisible: false,
    };
  }

  componentDidMount() {
    const { data, renewFlag, renewBusinessUuids } = this.state;
    if (data && data.stations.length > 0) {
      const diffMonth = getMonthNums(
        moment(data.beginDate).format('YYYY-MM-DD'),
        moment(data.endDate).format('YYYY-MM-DD'),
      );
      const stationsPrice = data.stations.reduce((prev, curr) => prev + curr.unit, 0);
      const originalPrice = diffMonth * stationsPrice;
      const discount = ((data.price / originalPrice) * 100).toFixed(2);
      this.setState({ originalPrice, discount });
    }

    this.props.dispatch(getIncuBaseList());
    this.getIncCustomList();
    if (data && data.customUuid) {
      this.customUuid = data.customUuid;
      this.setState({
        customUuid: data.customUuid,
      });
      this.getIncCustomProject();
    }
    if (data && data.stations) {
      this.getStationsPrice(data.stations);
    }
    if (renewFlag && renewBusinessUuids && renewBusinessUuids.length > 0) {
      this.renewBusinessInfo(renewBusinessUuids);
    }
  }

  componentWillUnmount() {
    if (this.saveFlag) {
      sessionDb.set('pageStationData', this.getpageStationData());
    } else {
      sessionDb.set('pageStationData', null);
    }
  }

  // 当前页面的数据存入storage
  getpageStationData = () => {
    const { data, stations } = this.state;
    const values = this.props.form.getFieldsValue();
    if (data) {
      values.uuid = data.uuid;
      values.businessUuid = data.businessUuid;
      values.incuabtorBusinessUuid = data.incuabtorBusinessUuid;
    }
    if (values.beginDate) {
      values.beginDate = moment(values.beginDate).valueOf();
    }
    if (values.endDate) {
      values.endDate = moment(values.endDate).valueOf();
    }
    return {
      ...values,
      ...this.state,
      stations: this.seatTable ? this.seatTable.state.selected : stations,
    };
  };

  // 客户列表
  getIncCustomList = (condition = '') => {
    queryIncCustomList({ condition }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          customList: res.data,
        });
      }
    });
  };

  // 搜索客户
  handleSearch = value => {
    this.getIncCustomList(value);
  };

  // 切换客户
  handleCustomChange = (e, option) => {
    this.props.form.setFieldsValue({ custom: option.props.children });
    this.props.form.setFieldsValue({ beginDate: undefined });
    this.customUuid = e;
    this.setState({
      customUuid: this.customUuid,
      renewBusinessUuids: [],
      renewBusinesses: [],
    });
    this.getIncCustomProject();
  };

  // 客户项目列表
  getIncCustomProject = (condition = '') => {
    queryIncCustomProject({
      customUuid: this.customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          projectList: res.data,
        });
      }
    });
  };

  // 获取孵化器的名字
  initIncubator = data => {
    const objIncubator = {};
    data.forEach(item => {
      objIncubator[item.uuid] = item.name;
    });
    this.props.form.setFieldsValue({
      incubator: objIncubator[this.props.params.uuid],
    });
  };

  // 入住合同保存
  saveIncuSettled = params => {
    this.setState({
      submiting: true,
    });
    querySaveIncuSettled(params).then(res => {
      this.setState({
        submiting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/setteled_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  handleProjectChange = (e, option) => {
    this.props.form.setFieldsValue({ projectName: option.props.children });
  };

  getSum = data => {
    return data.reduce((prev, current) => {
      return prev + current.price;
    }, 0);
  };

  // 验证文件不为空
  validateFile = () => {
    const { fileList } = this.state;
    const requiredFile = ['10', '1;', '2;'];
    if (!fileList.length) {
      message.warn('没有选择附件！');
      this.setState({
        showFileTips: true,
      });
      return false;
    }
    const choosedType = fileList.reduce((prve, next) => {
      return `${prve + next.type};`;
    }, '');
    if (!requiredFile.every(item => choosedType.indexOf(item) > -1)) {
      message.warn('请查看附件是否上传完整！');
    } else {
      return true;
    }
  };

  // 删除流程
  handleDelete = uuid => {
    queryDeleteIncuSettled({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/setteled_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  // 提交申请流程
  submit = op => e => {
    if (e) {
      e.preventDefault();
    }
    const { payables, stationUuids, fileList, renewFlag, renewBusinessUuids } = this.state;
    const { data } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // if (!stationUuids.length) {
        //   message.warn("没有选择工位！");
        //   return;
        // }
        if (+this.getSum(payables) !== +values.indeposit + +values.price) {
          message.warn('合同款不符！');
          return;
        }
        if (!this.validateFile()) {
          return;
        }
        if (data) {
          values.uuid = data.uuid;
          values.businessUuid = data.businessUuid;
          values.incuabtorBusinessUuid = data.incuabtorBusinessUuid;
        }
        if (renewFlag) {
          values.renewBusinessUuids = renewBusinessUuids;
        }
        const params = {
          ...values,
          beginDate: moment(values.beginDate).format('YYYY-MM-DD'),
          endDate: moment(values.endDate).format('YYYY-MM-DD'),
          payables,
          stationUuids,
          stationNum: stationUuids.length,
          files: fileList,
        };
        delete params.renewFlag;
        if (op === 'audit') {
          this.saveIncuSettled(params);
        } else {
          message.warn('保存草稿功能正在开发，敬请期待！');
        }
      }
    });
  };

  // --------------------------关于付款约定--------------------------------------
  // 确定选择工位
  handleSetStation = () => {
    this.handleVisible(false);
  };

  // 工位列表弹窗
  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  // 选择工位发生变化
  handleStationChange = (stationUuids, price) => {
    this.stationsPrice = price;
    this.setPrice();
    this.setState({
      stationUuids,
    });
  };

  onBeginDateChange = (date, dateString) => {
    const values = this.props.form.getFieldsValue();
    if (values.endDate) {
      this.onRangeChange([date, values.endDate], [dateString, values.endDate.format('YYYY-MM-DD')]);
    }
  };

  onEndDateChange = (date, dateString) => {
    const values = this.props.form.getFieldsValue();
    if (values.beginDate) {
      this.onRangeChange(
        [values.beginDate, date],
        [values.beginDate.format('YYYY-MM-DD'), dateString],
      );
    }
  };

  // 入驻周期变化自动填充付款约定
  onRangeChange = (date, dateString) => {
    const beginDate = dateString[0].split('-');
    this.date = date;

    this.diffMonth = getMonthNums(dateString[0], dateString[1]);

    this.startYear = +beginDate[0];
    this.startMonth = +beginDate[1];
    this.startDate = beginDate[2];

    const quartNum = Math.floor(this.diffMonth / 3);

    const payable = [];
    // 押金
    payable.push({
      beginDate: moment(dateString[0], 'YYYY-MM-DD').valueOf(),
      endDate: moment(dateString[1], 'YYYY-MM-DD').valueOf(),
      date: moment(dateString[0], 'YYYY-MM-DD').add(15, 'd').valueOf(),
      nums: 1,
      type: 0,
    });
    // 工位收入
    for (let i = 0; i < quartNum; i++) {
      const delayDays = i === 0 ? 15 : 1;
      let endDate = this.getNextYearMonth(3 * (i + 1), -1);
      if (i === quartNum - 1 && !(this.diffMonth % 3)) {
        endDate = moment(dateString[1], 'YYYY-MM-DD').valueOf();
      }
      payable.push({
        beginDate: this.getNextYearMonth(3 * i),
        endDate,
        date: this.getNextYearMonth(3 * i, delayDays),
        nums: 3,
        type: 1,
      });
    }
    if (this.diffMonth % 3) {
      const delayDays = quartNum === 0 ? 15 : 1;
      payable.push({
        beginDate: this.getNextYearMonth(3 * quartNum),
        endDate: moment(dateString[1], 'YYYY-MM-DD').valueOf(),
        date: this.getNextYearMonth(3 * quartNum, delayDays),
        nums: this.diffMonth % 3,
        type: 1,
      });
    }
    this.payableData = payable;
    this.setPrice();
  };

  // 更新付款约定
  handleAppointChange = payables => {
    this.setState({ payables });
  };

  // 获取付款约定对应的时间
  getNextYearMonth = (numMonth, days) => {
    return getDate(this.startYear, this.startMonth, this.startDate, numMonth, days);
  };

  /**
   * 根据工位价格和时间自动算出合同金额
   */
  setPrice = () => {
    if (this.stationsPrice && this.diffMonth) {
      const price = this.stationsPrice * this.diffMonth;
      const indeposit = this.stationsPrice;
      this.props.form.setFieldsValue({
        price,
        indeposit,
      });
      this.setState({
        price,
        indeposit,
        discount: 100,
        originalPrice: price,
      });

      if (this.payableData) {
        this.payableData.map(item => {
          item.price = item.nums * this.stationsPrice;
          return item;
        });
      }
      this.payable.setPayableData(this.payableData);
      this.handleAppointChange(this.payableData);
    }
  };

  // ----------------------------------------关于文件------------------------------------------------
  // 文件选择模态框
  handleFileVisible = flag => {
    this.setState({
      fileVisible: !!flag,
    });
  };

  // 确认选择文件
  handleChooseFile = params => {
    this.setState({
      fileList: params,
      showFileTips: params.length === 0,
    });
  };

  // ------------------------------关于转结-----------------------------------------------

  handleCarryVisible = flag => {
    this.setState({
      carryVisible: !!flag,
    });
  };

  startTurn = index => {
    this.outIndex = index;
    this.innerIndex = -1;
    this.turnItem = {}; // 编辑转结弹框对应的转结
    this.turnItem2 = {}; // 付款约定列表对应的转结
    this.handleCarryVisible(true);
  };

  // 编辑或新增转结
  handleTurn = params => {
    const { payables } = this.state;
    payables[this.outIndex].turns = payables[this.outIndex].turns || [];
    const newTurnItem = {
      businessUuid: params.oldBusinessUuid,
      payableUuid: params.oldPayableUuid,
      payableNo: params.payableNo,
      price: params.price,
      type: params.type,
    };
    if (this.innerIndex > -1) {
      if (this.turnItem2.uuid) {
        newTurnItem.uuid = this.turnItem2.uuid;
      }
      payables[this.outIndex].turns[this.innerIndex] = newTurnItem;
    } else {
      payables[this.outIndex].turns.push(newTurnItem);
    }
    this.handleCarryVisible(false);
    this.setState(payables);
  };

  // 删除转结
  handleTurnDelete = (record, outIndex, innerIndex) => {
    const { payables } = this.state;
    let { turns } = payables[outIndex];
    if (record.uuid) {
      turns = turns.filter(item => item.uuid !== record.uuid);
    } else {
      turns.splice(innerIndex, 1);
    }
    payables[outIndex].turns = turns;
    this.setState({
      payables,
    });
  };

  // 转结编辑
  handleTurnEdit = (record, outIndex, innerIndex) => {
    this.turnItem = record || {};
    if (record) {
      this.turnItem2 = record;
      this.turnItem = {
        price: record.price,
        uuid: record.payableUuid,
        businessUuid: record.businessUuid,
        no: record.payableNo,
        type: record.type,
      };
    }
    this.outIndex = outIndex;
    this.innerIndex = innerIndex;
    this.handleCarryVisible(true);
  };

  // ------------------------------关于续签-----------------------------------------------
  // 关于续签
  handleChooseSettled = (renewBusinessUuids, renewBusinesses) => {
    if (renewBusinessUuids) {
      this.setState({
        showSettledTips: false,
      });
    }
    this.renewBusinessInfo(renewBusinessUuids);
    this.setState({
      renewBusinessUuids,
      renewBusinesses,
    });
  };

  handleSettledVisible = flag => {
    this.setState({
      settledVisible: !!flag,
    });
  };

  handleRenewChange = e => {
    this.setState({
      renewFlag: e.target.value,
    });
  };

  // 获取续签合同的详情
  renewBusinessInfo = businessUuids => {
    queryRenewBusinessInfo({
      businessUuids,
    }).then(res => {
      if (res.statusCode === 200) {
        this.getStationsPrice(res.data.stations);
        this.setPrice();
        this.setState({
          stations: res.data.stations,
          stationUuids: res.data.stations.map(item => item.uuid),
        });
        this.props.form.setFieldsValue({
          beginDate: moment.unix((res.data.beginDate + 86400000) / 1000),
        });
      } else {
        message.error(res.message);
      }
    });
  };

  changePage = renewBusinessUuid => {
    this.saveFlag = true;
    browserHistory.push(`/incubator/contract/${renewBusinessUuid}/info`);
  };

  // --------------------------------其他操作-------------------------------------
  handlePriceChange = e => {
    const { value } = e.target;
    const { originalPrice } = this.state;
    const discount = ((value / originalPrice) * 100).toFixed(2);
    this.setState({ price: value, discount });
  };

  handleIndepositChange = e => {
    this.setState({ indeposit: e.target.value });
  };

  getStationsPrice = stations => {
    this.stationsPrice = stations.reduce((prev, curr) => prev + curr.unit, 0);
  };

  getIncubatorName = incubatorUuid => {
    const { incubatorList } = this.props;
    const currentIncu = incubatorList.find(item => item.uuid === incubatorUuid);
    return currentIncu ? currentIncu.name : '';
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      customList,
      visible,
      fileVisible,
      stationUuids,
      projectList,
      incubatorUuid,
      payables,
      price,
      discount,
      originalPrice,
      indeposit,
      customUuid,
      fileList,
      showFileTips,
      carryVisible,
      submiting,
      showSettledTips,
      settledVisible,
      renewBusinessUuids,
      renewBusinesses,
      renewFlag,
      stations,
    } = this.state;
    const { data } = this.state;
    const ItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };

    const ItemLayout2 = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };
    getFieldDecorator('custom', { initialValue: data ? data.custom : '' });
    getFieldDecorator('projectName', {
      initialValue: data ? data.projectName : '',
    });
    const incubatorName = this.getIncubatorName(data ? data.incubatorUuid : this.props.params.uuid);
    getFieldDecorator('incubator', { initialValue: incubatorName });
    getFieldDecorator('incubatorUuid', {
      initialValue: data ? data.incubatorUuid : this.props.params.uuid,
    });
    return (
      <Form>
        <div style={{ marginBottom: 15 }}>
          <BackBtn />
          <FlowOp handleClick={this.submit} loading={submiting} />
          {data && data.uuid ? (
            <Button
              icon="delete"
              style={{ marginRight: 10 }}
              onClick={() => this.handleDelete(data.uuid)}
            >
              删除
            </Button>
          ) : null}
        </div>
        <Card title="签约主体" className="mb16">
          <Row>
            <Col span={10}>
              <FormItem label="公司名称" {...ItemLayout}>
                {getFieldDecorator('customUuid', {
                  rules: [{ required: true, message: '请输入公司名称!' }],
                  initialValue: data ? data.customUuid : '',
                })(
                  <Select
                    onChange={this.handleCustomChange}
                    showSearch
                    filterOption={false}
                    onSearch={this.handleSearch}
                  >
                    {data && data.customUuid ? (
                      <Option key={data.customUuid}>{data.custom}</Option>
                    ) : null}
                    {(customList || []).map(item => {
                      return <Option key={item.customUuid}>{item.customName}</Option>;
                    })}
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="项目名称" {...ItemLayout}>
                {getFieldDecorator('projectId', {
                  initialValue: data ? data.projectId : '',
                })(
                  <Select onChange={this.handleProjectChange}>
                    {(projectList || []).map(item => (
                      <Option key={item.id}>{item.projectName}</Option>
                    ))}
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="孵化器" {...ItemLayout}>
                {incubatorName}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="是否续签" {...ItemLayout}>
                {getFieldDecorator('renewFlag', {
                  rules: [{ required: true, message: '请选择是否是否续签 !' }],
                  initialValue: renewFlag,
                })(
                  <RadioGroup name="renewFlag" onChange={this.handleRenewChange}>
                    <Radio value={1}>是</Radio>
                    <Radio value={0}>否</Radio>
                  </RadioGroup>,
                )}
              </FormItem>
            </Col>
          </Row>
          {renewFlag ? (
            <Col span={20}>
              <FormItem label="对应续签合同" {...ItemLayout2}>
                {customUuid ? (
                  <a onClick={() => this.handleSettledVisible(true)}>选择对应续签合同</a>
                ) : null}
                {showSettledTips ? (
                  <span style={{ color: 'red', paddingLeft: '10px' }}>选择对应续签合同！</span>
                ) : null}
                {renewBusinessUuids.length > 0 ? (
                  <TableRenew dataSource={renewBusinesses} changePage={this.changePage} />
                ) : null}
              </FormItem>
            </Col>
          ) : null}
        </Card>

        <Card title="租赁条款" className="mb16">
          <Row>
            <Col span={20}>
              <FormItem label="收入类型" {...ItemLayout2}>
                {getFieldDecorator('type', {
                  rules: [{ required: true, message: '请选择收入类型!' }],
                  initialValue: data ? data.type : '',
                })(
                  <RadioGroup>
                    <Radio value={0}>工位收入</Radio>
                    <Radio value={1}>地址收入</Radio>
                  </RadioGroup>,
                )}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="使用工位" {...ItemLayout2}>
                <span>{stationUuids.length}个</span>
                <Button onClick={() => this.handleVisible(true)} style={{ marginLeft: '8px' }}>
                  编辑
                </Button>
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="开始时间" {...ItemLayout}>
                {getFieldDecorator('beginDate', {
                  rules: [{ required: true, message: '请选择计租时间!' }],
                  initialValue:
                    data && data.beginDate ? moment.unix(data.beginDate / 1000) : undefined,
                })(
                  <DatePicker
                    format={dateFormat}
                    style={{ width: '100%' }}
                    disabled={renewFlag}
                    onChange={this.onBeginDateChange}
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="结束时间" {...ItemLayout}>
                {getFieldDecorator('endDate', {
                  rules: [{ required: true, message: '请选择到期时间!' }],
                  initialValue: data && data.endDate ? moment.unix(data.endDate / 1000) : undefined,
                })(
                  <DatePicker
                    format={dateFormat}
                    style={{ width: '100%' }}
                    onChange={this.onEndDateChange}
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={10} style={{ position: 'relative' }}>
              <FormItem label="合同费用" {...ItemLayout}>
                {getFieldDecorator('price', {
                  rules: [{ required: true, message: '请输入合同费用!' }],
                  initialValue: data ? data.price : '',
                })(<Input placeholder="合同费用" onChange={this.handlePriceChange} />)}
              </FormItem>
              {+discount > 0 && +discount < 100 ? (
                <span
                  style={{
                    position: 'absolute',
                    bottom: '3px',
                    left: '180px',
                    color: 'red',
                  }}
                >
                  原价{originalPrice}元，折扣{discount}%
                </span>
              ) : (
                ''
              )}
            </Col>
            <Col span={10}>
              <FormItem label="押金" {...ItemLayout}>
                {getFieldDecorator('indeposit', {
                  rules: [{ required: true, message: '请输入押金!' }],
                  initialValue: data ? data.indeposit : '',
                })(<Input placeholder="押金" onChange={this.handleIndepositChange} />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="推荐人员" {...ItemLayout}>
                {getFieldDecorator('recommend', {
                  rules: [
                    {
                      required: !(+price || +indeposit),
                      message: '请输入推荐人员',
                    },
                  ],

                  initialValue: data ? data.recommend : '',
                })(<Input placeholder="推荐人员" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="联系电话" {...ItemLayout}>
                {getFieldDecorator('recommendTel', {
                  rules: [
                    {
                      required: !(+price || +indeposit),
                      message: '请输入联系电话',
                    },
                  ],
                  initialValue: data ? data.recommendTel : '',
                })(<Input placeholder="联系电话" />)}
              </FormItem>
            </Col>
          </Row>
        </Card>
        <div className="mb16">
          <TableAppoint
            handleChange={this.handleAppointChange}
            dataSource={payables}
            handleCarry={this.startTurn}
            handleTurnDelete={this.handleTurnDelete}
            handleTurnEdit={this.handleTurnEdit}
            indeposit={indeposit}
            price={price}
            ref={node => {
              this.payable = node;
            }}
          />
        </div>
        <Card title="合同审核" className="mb16">
          <Row>
            <Col span={20}>
              <FormItem label="相关附件" {...ItemLayout2}>
                {customUuid ? (
                  <span>
                    <div>
                      <a onClick={() => this.handleFileVisible(true)}>选择附件</a>
                    </div>
                    <span>必选文件：基础孵化协议 、法人身份证 、消防安全责任书</span>
                  </span>
                ) : null}
                {showFileTips ? (
                  <span style={{ color: 'red', paddingLeft: '10px' }}>附件必须上传！</span>
                ) : null}
                {fileList.length > 0 ? (
                  <TableFile dataSource={fileList} handleChooseFile={this.handleChooseFile} />
                ) : null}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="入驻说明" {...ItemLayout2}>
                {getFieldDecorator('reason', {
                  rules: [{ required: true, message: '请输入reason!' }],
                  initialValue: data ? data.reason : '',
                })(
                  <Input.TextArea
                    placeholder="入驻说明"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                    maxLength={1000}
                  />,
                )}
                <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
              </FormItem>
            </Col>
          </Row>
        </Card>
        <Modal
          visible={visible}
          width={900}
          title="选择工位"
          onCancel={() => this.handleVisible(false)}
          onOk={this.handleSetStation}
        >
          <ComSeatTable
            {...this.props}
            incubatorUuid={incubatorUuid}
            handleChange={this.handleStationChange}
            stations={stations}
            ref={node => {
              this.seatTable = node;
            }}
          />
        </Modal>
        {fileVisible ? (
          <ModalFileList
            customUuid={customUuid}
            fileVisible={fileVisible}
            selectedRows={fileList}
            handleCancel={this.handleFileVisible}
            handleChooseFile={this.handleChooseFile}
          />
        ) : null}

        {settledVisible ? (
          <ModalSettledList
            type="settled"
            customUuid={customUuid}
            incubatorUuid={data ? data.incubatorUuid : this.props.params.uuid}
            selectedRowKeys={renewBusinessUuids}
            selectedRows={renewBusinesses}
            visible={settledVisible}
            changePage={this.changePage}
            handleCancel={this.handleSettledVisible}
            onOk={this.handleChooseSettled}
          />
        ) : null}
        {carryVisible ? (
          <ModalCarry
            onCancel={() => this.handleCarryVisible(false)}
            customUuid={customUuid}
            incubatorUuid={incubatorUuid}
            type={(payables[this.outIndex] || {}).type !== 0 ? 1 : 0}
            renewBusinessUuids={renewBusinessUuids}
            handleTurn={this.handleTurn}
            data={this.turnItem}
          />
        ) : null}
      </Form>
    );
  }
}

export default connect(state => ({
  incubatorList: state.incubator_list,
}))(Form.create({ wrappedComponentRef: true })(PageStation));



// WEBPACK FOOTER //
// ./src/components/incubator/contract/station/PageStation.js